import { render, staticRenderFns } from "./wine-club-message-info.vue?vue&type=template&id=55cd64c1&"
import script from "./wine-club-message-info.vue?vue&type=script&lang=js&"
export * from "./wine-club-message-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports